import { FILTERS_NAME } from '@constants/filters';
import { useAppSelector } from '@store/hooks/redux';
import { IState } from '@store/reducers/filters';
import { getFilters, getOneFilter } from '@store/selectors/filters';

export const useFilters = (): IState['filters'] => useAppSelector(getFilters);
export const useOneFilter = (filterName: FILTERS_NAME): IState['filters'][FILTERS_NAME] =>
  useAppSelector(getOneFilter(filterName));
